export default "__VITE_ASSET__DDMSg6i5__"